import { FC } from 'react';

interface DocumentProps {
	className?: string;
}

const Document: FC<DocumentProps> = ({ className }) => {
	return (
		<svg
			className={className}
			width="45"
			height="46"
			viewBox="0 0 45 46"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M44.5 22.5C44.5 26.8512 43.2097 31.1047 40.7923 34.7226C38.3749 38.3404 34.939 41.1602 30.919 42.8254C26.899 44.4905 22.4756 44.9261 18.208 44.0773C13.9404 43.2284 10.0204 41.1331 6.94368 38.0563C3.86693 34.9796 1.7716 31.0595 0.922729 26.792C0.0738542 22.5244 0.509546 18.1009 2.17467 14.0809C3.8398 10.061 6.6596 6.62503 10.2775 4.20763C13.8954 1.79025 18.1488 0.5 22.5 0.5C28.3348 0.5 33.9305 2.81783 38.0563 6.94363C42.1821 11.0694 44.5 16.6652 44.5 22.5Z"
				fill="#E3EEFF"
			/>
			<rect y="0.5" width="45" height="45" rx="10" fill="#E3EEFF" />
			<path
				d="M18.0143 12.25H29.1723C29.4214 12.25 29.6602 12.349 29.8364 12.5251C30.0125 12.7012 30.1114 12.9401 30.1114 13.1892V32.1532C30.1114 32.2765 30.0871 32.3986 30.0399 32.5125C29.9928 32.6265 29.9236 32.73 29.8364 32.8172C29.7492 32.9044 29.6456 32.9736 29.5317 33.0208C29.4177 33.068 29.2956 33.0923 29.1723 33.0923H15.5563C15.433 33.0923 15.3109 33.068 15.1969 33.0208C15.083 32.9736 14.9795 32.9044 14.8923 32.8172C14.805 32.73 14.7359 32.6265 14.6887 32.5125C14.6415 32.3986 14.6172 32.2765 14.6172 32.1532V15.648C14.6171 15.5245 14.6415 15.4021 14.6888 15.288C14.7361 15.1739 14.8055 15.0702 14.893 14.9829L17.351 12.5249C17.4382 12.4377 17.5418 12.3686 17.6557 12.3214C17.7697 12.2742 17.8919 12.25 18.0152 12.25H18.0143Z"
				fill="#E3EEFF"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.8574 15.6671H17.8294C17.9496 15.6671 18.065 15.6193 18.15 15.5343C18.235 15.4493 18.2828 15.3339 18.2828 15.2137V12.2656"
				fill="#E3EEFF"
			/>
			<path
				d="M14.8574 15.6671H17.8294C17.9496 15.6671 18.065 15.6193 18.15 15.5343C18.235 15.4493 18.2828 15.3339 18.2828 15.2137V12.2656"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22.3926 17.5918H27.5289"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.2656 17.5918H20.5629"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M25.875 19.6641H27.4118"
				stroke="#5D9BFD"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.1055 19.6641H24.1363"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.082 25.8789H24.509"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.9727 23.8086H27.5996"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.3066 23.8086H19.2473"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.7266 21.7344H27.0036"
				stroke="#5D9BFD"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default Document;
